const SUSPENDED_NOTIFICATION_NAMESPACE = 'my_account.suspended_notification';
const SUSPENDED_NOTIFICATION_PAYMENTS_NAMESPACE = 'my_account.suspended_notification_payments';

export { SUSPENDED_NOTIFICATION_NAMESPACE, SUSPENDED_NOTIFICATION_PAYMENTS_NAMESPACE };
